import React, { useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import authAPI from '../../services/authAPI';
import AuthShell, { inputClass, labelClass, buttonClass, Notice } from '../../components/Auth/AuthShell';

// Flatten DRF validation errors ({field: [msg]} / {error: msg}) into readable lines
const errorLines = (data) => {
  if (!data) return ['Something went wrong. Please try again.'];
  if (typeof data === 'string') return [data];
  return Object.values(data).flat().map(String);
};

const ResetPasswordPage = () => {
  const { uid, token } = useParams();
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const [errors, setErrors] = useState([]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirm) {
      setErrors(["The two passwords don't match."]);
      return;
    }
    setLoading(true);
    setErrors([]);
    try {
      await authAPI.confirmPasswordReset(uid, token, password, confirm);
      setDone(true);
    } catch (err) {
      setErrors(err.response?.status === 429
        ? ['Too many attempts. Please wait a while and try again.']
        : errorLines(err.response?.data));
    } finally {
      setLoading(false);
    }
  };

  if (done) {
    return (
      <AuthShell title="Password updated">
        <div className="space-y-6">
          <Notice tone="success">Your password has been changed and you've been signed out everywhere else.</Notice>
          <Link to="/login" className={buttonClass}>Sign in</Link>
        </div>
      </AuthShell>
    );
  }

  return (
    <AuthShell title="Choose a new password" subtitle="Use at least 8 characters that aren't easy to guess.">
      <form className="space-y-4" onSubmit={handleSubmit}>
        <div>
          <label htmlFor="new-password" className={labelClass}>New password</label>
          <input
            id="new-password"
            type="password"
            autoComplete="new-password"
            required
            minLength={8}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className={inputClass}
            placeholder="New password"
          />
        </div>
        <div>
          <label htmlFor="confirm-password" className={labelClass}>Confirm new password</label>
          <input
            id="confirm-password"
            type="password"
            autoComplete="new-password"
            required
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
            className={inputClass}
            placeholder="Confirm new password"
          />
        </div>
        {errors.length > 0 && (
          <Notice>
            {errors.map((line) => <div key={line}>{line}</div>)}
            {errors.some((l) => /invalid|expired/i.test(l)) && (
              <Link to="/forgot-password" className="mt-2 inline-block font-medium underline">Request a new link</Link>
            )}
          </Notice>
        )}
        <button type="submit" disabled={loading} className={buttonClass}>
          {loading ? 'Saving…' : 'Set new password'}
        </button>
      </form>
    </AuthShell>
  );
};

export default ResetPasswordPage;
